export const manageDevices = {
	deviceListByPlace: {
		title: "Lista de equipamentos por local",
		totalDevices: "Total de equipamentos",
		table: {
			emptyState: {
				title: "Ainda não tem nada por aqui",
			},
			columns: {
				contractStatus: "Status do contrato",
				contractId: "ID do contrato",
				quantity: "Quantidade",
				serialNumber: "Número de série",
				equipmentModel: "Modelo",
			},
		},
		filters: {
			byContractId: "Filtrar por ID de contrato",
			bySerialNumber: "Filtrar por número de série",
			byModel: "Filtrar por modelo",
			byStatus: "Filtrar por status",
		},
		tag: {
			pendingSignature: "Assinatura pendente",
			signatureExpired: "Assinatura expirada",
			contractExpired: "Contrato vencido",
			active: "Contrato ativo",
			closed: "Contrato encerrado",
		},
		btnExport: "Exportar",
		requestEquipments: "Solicitar equipamentos",
	},
};
